export const permissions = {
  DASHBOARD: {
    LIST: '72ef3f6a-2612-11ec-9621-0242ac130002',
  },
  RETENTIONS: {
    LIST: 'd5f3c1e2-2612-11ec-9621-0242ac130002',
    APPROVE_CANCELATION: 'e6b5f4c4-2612-11ec-9621-0242ac130002',
    REACTIVATE_SUBSCRIPTION: 'f0a6b1d0-2612-11ec-9621-0242ac130002',
    REQUEST_CANCELATION: 'f0a6b1d1-2612-11ec-9621-0242ac130002',
    RECORD_CREATE: 'f1c3d4a6-2612-11ec-9621-0242ac130002',
  },
  LEADS: {
    LIST: '774941c8-2612-11ec-9621-0242ac130002',
    IMPORT: '7ae037ba-2612-11ec-9621-0242ac130002',
    INFORM_ACTION: '88956df8-2612-11ec-9621-0242ac130002',
    ARCHIVE: '8c23654c-2612-11ec-9621-0242ac130002',
    CREATE: '94447ab8-2612-11ec-9621-0242ac130002',
    DEFINE_RESPONSIBLE_USER: '91b0a34e-2612-11ec-9621-0242ac130002',
    UPDATE: '8e8d167a-2612-11ec-9621-0242ac130002',
    EXPORT: '52cf6f43-8654-4245-9e65-d07582961955',
    REACTIVATE_ARCHIVED: '57383fe3-85ad-491a-93d1-923f7f26e431',
  },
  SUBSCRIBERS: {
    LIST: '9f0355f0-2612-11ec-9621-0242ac130002',
    UPDATE: 'b387b7ba-2926-42d5-bc40-4050b8d37b28',
    CREATE: '9bf610e8-247e-46e6-b9bd-f289e0686cdd',
    INFORM_ACTION: 'a2ba3d1c-2612-11ec-9621-0242ac130002',
    EXPORT: '46e5efae-01cc-4b9f-b022-4e5e29067ccb',
    SUBSCRIPTION_DETAILS: 'b49edda4-98f1-4e23-bece-b882efbb0ff1',
    CREATE_SYSTEM_SUBSCRIPTION: 'd68f89a4-61ea-4e0c-94b1-367533afcef0',
    CREATE_SYSTEM_SUBSCRIPTION_AMENDMENT:
      'c29ae62a-d5d1-4001-8dd9-71ae8089d978',
    CREATE_RENTAL_SUBSCRIPTION: 'a7f3c8b2-4d9e-4a1c-8f6d-2e5b9c7a1d3f',
    CREATE_RENTAL_SUBSCRIPTION_AMENDMENT:
      'ce3cf350-4479-4abb-9186-8bce0e281321',
    CONSUMPTION_DETAILS: 'bcf61cdc-a1f1-4d13-964a-9c622629f1ca',
  },
  RESALES: {
    LIST: '5d32d6bb-e552-4d67-b275-69c46420eeea',
    INFORM_ACTION: 'e9217854-9541-4992-8cb7-2740576fae4d',
    UPDATE: '53602953-29d2-490d-b537-7fb09508f6f3',
    CREATE: 'b46204d0-2141-4511-b018-6a226384b1ba',
    ACTIVE: 'ab925bbe-491f-4235-8c52-d87ccfdc3433',
    BLOCK: '6698ecc9-f833-4ccd-8f0f-9b39496917f3',
    CANCEL: '4a9cd89a-758c-45b0-829a-37ed04804230',
  },
  USERS: {
    LIST: '3db52700-fb23-4507-8d67-bb3433de75b6',
    CREATE: 'afea3952-6e80-41dc-b239-99ac4ae1ca0b',
    UPDATE: '4e4c1eac-f90b-4bd6-a7f6-0a6b04c3249a',
    UPDATE_STATUS: '0694730d-39c1-458b-82f5-9a633a322a86',
  },
  PERMISSIONS_GROUPS: {
    LIST: '10700fce-79a3-48b0-a04e-73d857f484de',
    CREATE: '3f60b09c-56a2-4b07-938b-a20c07dab8cf',
    UPDATE: '41fc3823-92e1-4350-84e5-dd6413d5d7c3',
  },
  ACTIONS: {
    LIST: '4a45be3d-6b09-4eb4-9971-8201a168cbfe',
    CREATE: 'fc60834a-ccb8-4755-ab7f-2c4564970e30',
    UPDATE: '02cede44-d743-434a-b0b5-fe154ccf142e',
  },
  OFFERS: {
    LIST: 'ecbb230f-b396-4a5f-b05b-06859467e3d0',
    CREATE: '73e84f06-c3a9-4fb3-817d-482989e73b90',
    UPDATE: 'bea281b8-702f-4d68-a362-41868d3004f6',
  },
  OFFER_PURCHASES: {
    LIST: 'cb10d104-5b84-4fe7-9149-f0130337fa84',
    INFORM_ACTION: 'a7c19717-9510-41e5-b6f7-3fb6aff066c7',
    SEND_CREDENTIALS: '0edce18a-0146-4660-a357-2dc4967a9e7a',
    UPDATE: '9ca9df7c-e23c-4d8c-b882-393a55e84870',
  },
  HELP: {
    LIST: '72939c34-185c-4611-b454-31bc6b828b80',
    INFORM_ACTION: 'b27a2dc7-c268-44f2-9ac6-557d8b37580f',
  },
  OPERATING_AREAS: {
    LIST: '01990c22-9a16-7051-b619-cd861d499d77',
    CREATE: '01990c23-262c-772a-b110-45ffeda7f065',
    UPDATE: '01990c23-1666-76cd-be33-2d5bce6a8c55',
    UPDATE_STATUS: '01990c23-3439-7529-a769-5af564324b62',
  },
  FINANCIAL_TITLES: {
    LIST: 'd1a5a6e0-2612-11ec-9621-0242ac130002',
    EXPORT: 'd4c3f0e4-2612-11ec-9621-0242ac130002',
  },
  FINANCIAL_PAYOUT: {
    LIST: '3cdcccb1-b362-4438-8e0b-7d9e2ff6bc40',
    DETAILS: 'e4a517c1-04d7-4f9b-af08-f6b0d65aa1eb',
    CREATE: '28474d80-9f3c-4e2d-a6cb-ce5943f4c416',
  },
};
